// extracted by mini-css-extract-plugin
export default {"recommendations":"axtLhuthn3q47eEIWMiL-RecommendationList-recommendations"};